import request from '@/utils/request'

export function index(params) {
  return request({
      url: 'settings/work_types',
      method: 'get',
      params: params
  })
}


export function inventory(params) {
  return request({
      url: 'settings/work_type/inventory',
      method: 'get',
      params
  })
}

export function show(id) {
  return request({
      url: `settings/work_types/${id}`,
      method: 'get'
  })
}

export function store(data) {
  return request({
      url: 'settings/work_types',
      method: 'post',
      data
  })
}

export function update(data) {
  return request({
      url: `settings/work_types/${data.id}`,
      method: 'put',
      data
  })
}

export function destroy(id) {
  return request({
      url: `settings/work_types/${id}`,
      method: 'delete',
  })
}
